import videojs from "!video.js";
window.videojs = videojs;
import 'video.js/dist/video-js.min.css';